import { render, staticRenderFns } from "./CharactersClassImprovements.vue?vue&type=template&id=0d22fde6&lang=pug&"
import script from "./CharactersClassImprovements.vue?vue&type=script&lang=ts&"
export * from "./CharactersClassImprovements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports